// extracted by mini-css-extract-plugin
export default {"chartCard":"ChartCard_chartCard__lN8kj","title":"ChartCard_title__LDMM9","axisTitle":"ChartCard_axisTitle__w2qpq"};